import { currentUser, currentClientWebsite } from './utils';
import { get } from 'svelte/store';
export async function getMetrics(
	startDate,
	endDate,
	attribution,
	numberOfProducts,
	page,
	orderId = null,
	breakdown = 'attribution_order_table',
	device = null,
	page_type = null
) {
	let usr = get(currentUser);
	console.log(usr);

	const paramsObj = {
		cid: usr.clientId,
		// cid: 'KbUN8bQUwBGgTBg1R5Vb',
		start_date: startDate,
		end_date: endDate,
		attribution: attribution,
		number_of_products: numberOfProducts,
		page: page,
		breakdown: breakdown,
		order_id: orderId,
		device: device,
		page_type: page_type
	};

	let website = get(currentClientWebsite);
	if (website && website.length > usr.clientId.length) {
		paramsObj.website = website.split('-')[1];
	}

	Object.keys(paramsObj).forEach((key) => {
		if (paramsObj[key] === null) {
			delete paramsObj[key];
		}
	});

	const url = `https://reporting.shopbox.ai/api/v1/metrics?${new URLSearchParams(
		paramsObj
	).toString()}`;

	const response = await fetch(url, {
		method: 'GET',
		headers: {
			// 'SB-USER-TOKEN':
			// 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE3MjkxNTQ1NTAsInN1YiI6IjA0ZDk1NWZmLWNhYzUtNDhiMy1hNDgzLTA5Yzk2MGFmYjA3ZiJ9.kPggkRZucccQnM3NUEGQU5QYkhS0TGtGguLy6CulOg0',
			'SB-USER-TOKEN': usr.accessToken,
			'Content-Type': 'application/json'
		}
	});

	if (!response.ok) {
		throw new Error(`HTTP error! status: ${response.status}`);
	}
	const data = await response.json();
	return data;
}

export let attributionSalesFunnel = (startDate, endDate, selectedDevice, selectedPageType) =>
	getMetrics(
		startDate,
		endDate,
		null,
		50,
		1,
		null,
		'attribution_sales_funnel',
		selectedDevice === 'all' ? null : selectedDevice,
		selectedPageType === 'all' ? null : selectedPageType
	);

export let attributionInpageElements = (startDate, endDate, selectedDevice, selectedPageType) =>
	getMetrics(
		startDate,
		endDate,
		null,
		50,
		1,
		null,
		'attribution_inpage_elements',
		selectedDevice === 'all' ? null : selectedDevice,
		selectedPageType === 'all' ? null : selectedPageType
	);

export let attributionInpageElementsChart = (
	startDate,
	endDate,
	selectedDevice,
	selectedPageType
) =>
	getMetrics(
		startDate,
		endDate,
		null,
		50,
		1,
		null,
		'attribution_inpage_element_chart',
		selectedDevice === 'all' ? null : selectedDevice,
		selectedPageType === 'all' ? null : selectedPageType
	);

export let attributionOrderTable = (
	startDate,
	endDate,
	selectedDevice,
	selectedPageType,
	page,
	attribution,
	orderID,
	pageSize = 20
) =>
	getMetrics(
		startDate,
		endDate,
		attribution == 'all' ? null : attribution,
		pageSize,
		page,
		orderID ? orderID : null,
		'attribution_order_table',
		selectedDevice === 'all' ? null : selectedDevice,
		selectedPageType === 'all' ? null : selectedPageType
	);
